import { RegistrationStatus } from '@exam-center/graphql';
import { ColorPalette } from '@shared/components';

export const registrationStatusLabel: Record<RegistrationStatus, string> = {
  [RegistrationStatus.OpenForRegistration]: 'เปิดรับสมัคร',
  [RegistrationStatus.TemporarilyClosed]: 'ปิดรับสมัครชั่วคราว',
  [RegistrationStatus.RegistrationClosed]: 'ปิดรับสมัคร',
  [RegistrationStatus.SessionFull]: 'รอบสอบเต็ม',
  [RegistrationStatus.Scheduled]: 'รอเปิดรับสมัคร',
  [RegistrationStatus.Canceled]: 'ยกเลิกรอบสอบ',
};

export const registrationStatusColor: Record<RegistrationStatus, ColorPalette> = {
  [RegistrationStatus.OpenForRegistration]: ColorPalette.SUCCESS,
  [RegistrationStatus.TemporarilyClosed]: ColorPalette.WARNING,
  [RegistrationStatus.RegistrationClosed]: ColorPalette.SECONDARY,
  [RegistrationStatus.SessionFull]: ColorPalette.ERROR,
  [RegistrationStatus.Scheduled]: ColorPalette.INFO,
  [RegistrationStatus.Canceled]: ColorPalette.ERROR,
};
